module.exports = __webpack_public_path__ + "static/media/user-34.0133c228.png";